import { getRoomDetail } from '@/actions/room';
import APIServices from '@/apiUtils/APIServices';
import LandingLayout from '@/components/landing/home/LandingLayout';
import Room from '@/components/landing/room/index';
import SEO from '@/components/landing/seo';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const RoomDetail = (props) => {
  const dispatch = useDispatch();
  const roomBySlug = useSelector((state: any) => state.roomReducer?.roomDetail);
  const router = useRouter();

  useEffect(() => {
    if (router?.query?.slug) {
      dispatch(getRoomDetail(router?.query?.slug));
    }
  }, [router?.query?.slug]);

  return (
    <>
      <SEO
        meta_title={props?.data?.title}
        meta_description={props?.data?.description}
        meta_keywords={props?.data?.title}
        photo={
          props?.data?.image
            ? props?.data?.image
            : 'https://learnsic.com/images/room-banner.webp'
        }
        canonical={`room/${props?.data?.slug}`}
      />
      <LandingLayout>
        <Room roomData={roomBySlug?.data} roomSlug={router?.query?.slug} />
      </LandingLayout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  params: { slug },
}) => {
  const { data, success } = await new APIServices(`/room-list/${slug}`).get();
  return {
    props: {
      data: success ? data : null,
    },
  };
};

export default memo(RoomDetail);
